import { Alert } from "@growtherapy/sprout-ui";
import { useDismissible } from "../../../hooks/useDismissible";
import { useEffect } from "react";

type UseDismissibleProps = ReturnType<typeof useDismissible>;

export type UpdatedUICalloutComponentProps = {
  isDismissed: UseDismissibleProps["isDismissed"];
  setDismissibleState: UseDismissibleProps["setDismissibleState"];
};
export function UpdatedUICalloutComponent({
  isDismissed,
  setDismissibleState,
}: UpdatedUICalloutComponentProps) {
  if (isDismissed) return null;

  return (
    <Alert
      className="sm:hidden w-full min-h-content bg-transparent"
      heading="This page has been updated!"
      headingAs="h2"
      onClose={() => setDismissibleState(new Date())}
      use="info"
    >
      You can now check your audio & video settings before your session.
    </Alert>
  );
}

const UPDATED_UI_FEATURE_NAME = "client-intro-state-v2";
const SEEN_IT_ONCE_DURATION = 1000 * 60 * 60 * 24 * 7; // 1 week
export function UpdatedUICallout() {
  const { isDismissed, dismissibleState, setDismissibleState } = useDismissible(
    UPDATED_UI_FEATURE_NAME,
  );

  const { dismissedAt } = dismissibleState;

  useEffect(() => {
    if (isDismissed) return;
    if (dismissedAt) return;

    setDismissibleState(Date.now() + SEEN_IT_ONCE_DURATION); // 1 week
  }, [dismissedAt, isDismissed, setDismissibleState]);

  return (
    <UpdatedUICalloutComponent
      isDismissed={isDismissed}
      setDismissibleState={setDismissibleState}
    />
  );
}
